'use client'

import { useEffect } from 'react'

/**
 * Last-resort boundary: catches failures in the root layout itself, which the
 * segment-level error.jsx files sit below and therefore cannot catch.
 *
 * It replaces the root layout when it renders, so it must supply its own <html>
 * and <body>. It also deliberately uses plain markup and inline styles rather
 * than MUI — if the theme provider or emotion cache is what threw, rendering MUI
 * components here would fail again and produce a blank page anyway.
 *
 * Next.js only shows this in production builds; in dev the error overlay wins.
 */
export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error('[global-error]', error)
  }, [error])

  return (
    <html lang='en'>
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          background: '#f4f5f7',
          color: '#1f2937'
        }}
      >
        <div style={{ maxWidth: 480, padding: 32, textAlign: 'center' }}>
          <h1 style={{ fontSize: 20, margin: '0 0 8px' }}>Kalpvruks could not start</h1>
          <p style={{ fontSize: 14, lineHeight: 1.6, margin: '0 0 20px', color: '#4b5563' }}>
            {error?.message || 'An unexpected error occurred while loading the application.'}
          </p>
          {error?.digest && (
            <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 20px' }}>Reference: {error.digest}</p>
          )}
          <button
            onClick={() => reset()}
            style={{
              padding: '8px 20px',
              fontSize: 14,
              border: 0,
              borderRadius: 6,
              background: '#1f9d57',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  )
}
